import type { Configuration, PopupRequest } from '@azure/msal-browser'

// 'entra' = real MSAL/Entra login; 'dev' = header-based user switch (no tenant).
export const AUTH_MODE: 'entra' | 'dev' =
    (import.meta.env.VITE_AUTH_MODE as 'entra' | 'dev') || 'dev'

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || ''
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID || 'common'
export const API_SCOPE = import.meta.env.VITE_ENTRA_API_SCOPE || ''

// MSAL configuration for Microsoft Entra ID (Azure AD).
export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}

// Scopes requested at login + for API access tokens.
export const loginRequest: PopupRequest = {
    scopes: API_SCOPE ? [API_SCOPE] : ['openid', 'profile', 'email'],
}

// DevUser is a fake principal for dev mode, mirroring the backend's seeded users.
export interface DevUser {
    id: string
    name: string
    email: string
    department: string // business unit; sent as X-Dev-Department
    roles: string[] // e.g. ['AIRMS.Dev.Access'] or ['AIRMS.Dev.Access','AIRMS.Dev.RiskManager']
}

// Roster matches seedDevUsers() in the backend so role-based views work locally.
// Dev mode uses the AIRMS.Dev.* roles (production uses AIRMS.Prod.*).
export const DEV_USERS: DevUser[] = [
    { id: 'dev-user-0001', name: 'Dev User', email: 'dev.user@unisys.com', department: 'Cloud, Applications & Infrastructure', roles: ['AIRMS.Dev.Access'] },
    { id: 'dev-manager-0001', name: 'Risk Manager', email: 'risk.manager@unisys.com', department: 'Ethics & Compliance', roles: ['AIRMS.Dev.Access', 'AIRMS.Dev.RiskManager'] },
    { id: 'dev-user-0002', name: 'Alice Chen', email: 'alice.chen@unisys.com', department: 'Digital Workplace Solutions', roles: ['AIRMS.Dev.Access'] },
    { id: 'dev-user-0003', name: 'Bob Martinez', email: 'bob.martinez@unisys.com', department: 'Federal & National Security', roles: ['AIRMS.Dev.Access'] },
    { id: 'dev-user-0004', name: 'Carol Okafor', email: 'carol.okafor@unisys.com', department: 'Ethics & Compliance', roles: ['AIRMS.Dev.Access'] },
]

const DEV_USER_KEY = 'genai_dev_user_id'

export function getStoredDevUser(): DevUser {
    const id = localStorage.getItem(DEV_USER_KEY)
    return DEV_USERS.find((u) => u.id === id) || DEV_USERS[0]
}

export function setStoredDevUser(id: string) {
    localStorage.setItem(DEV_USER_KEY, id)
}
